import { render, staticRenderFns } from "./UnbindDisks.vue?vue&type=template&id=1042a840"
import script from "./UnbindDisks.vue?vue&type=script&lang=js"
export * from "./UnbindDisks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports